import { render, staticRenderFns } from "./XeroLink.vue?vue&type=template&id=da604904&scoped=true"
import script from "./XeroLink.vue?vue&type=script&lang=js"
export * from "./XeroLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da604904",
  null
  
)

export default component.exports